import { useEffect, useRef } from "react";
import api from "../services/api";

// Pings /users/heartbeat while the tab is visible so the superadmin panel can
// show "usuarios conectados ahora" (feat_231). 270s (4.5min) interval; the
// "online" threshold on the backend is 5min, leaving margin for one miss.
const HEARTBEAT_INTERVAL_MS = 4.5 * 60 * 1000; // 270 seg

const useHeartbeat = () => {
  const timerRef = useRef(null);

  useEffect(() => {
    const ping = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        await api.post("/users/heartbeat");
      } catch (err) {
        /* fail-safe: presence is best-effort */
      }
    };

    ping();
    timerRef.current = setInterval(ping, HEARTBEAT_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") ping();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(timerRef.current);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);
};

export default useHeartbeat;
